export default __webpack_public_path__ + "static/media/LUNES.648d0cd5.jpeg";